import React from "react";
import { Canvas, Image, StyleSheet, Text, View } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: 900
  }
});

const iconMap = {
  envelope: "\uf0e0",
  phone: "\uf095",
  globe: "\uf57e",
  marker: "\uf276"
};

const brandIconMap = {
  github: "\uf09b"
};

export const Icon = ({ name, style }) => {
  let icon = iconMap[name];
  let isBrand = !icon;

  if (isBrand) {
    icon = brandIconMap[name];
  }

  return (
    <View
      style={[
        styles.icon,
        {
          fontFamily: isBrand ? "FontAwesomeBrands" : "FontAwesome"
        },
        style
      ]}
    >
      <Text children={icon} />
    </View>
  );
};
